var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNvidiaSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1039_5682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95137 8.80256V7.37818C9.09834 7.3635 9.23062 7.3635 9.37758 7.3635C13.3016 7.24602 15.8736 10.7409 15.8736 10.7409C15.8736 10.7409 13.0959 14.5735 10.1124 14.5735C9.71561 14.5735 9.33349 14.5147 8.95137 14.3826V10.0507C10.4798 10.2416 10.7885 10.9024 11.6997 12.4296L13.7426 10.7115C13.7426 10.7115 12.2435 8.75851 9.74501 8.75851C9.48046 8.75851 9.21592 8.77319 8.95137 8.80256ZM8.95137 4.07422V6.20344L9.37758 6.17407C14.8301 5.98318 18.3868 10.6381 18.3868 10.6381C18.3868 10.6381 14.301 15.6161 10.0536 15.6161C9.68622 15.6161 9.3188 15.5867 8.95137 15.5133V16.8349C9.24531 16.8642 9.55395 16.8936 9.86258 16.8936C13.816 16.8936 16.6819 14.8672 19.4596 12.4883C19.9152 12.8554 21.7964 13.7512 22.1933 14.133C19.5625 16.3356 13.4192 18.1124 9.93606 18.1124C9.59804 18.1124 9.2894 18.0977 8.96607 18.0537V19.9333H24.001V4.07422C24.001 4.07422 8.95137 4.07422 8.95137 4.07422ZM8.95137 14.3973V15.528C5.29185 14.8672 4.27777 11.0639 4.27777 11.0639C4.27777 11.0639 6.04139 9.12561 8.95137 8.80256V10.036H8.93668C7.4082 9.84514 6.20306 11.2842 6.20306 11.2842C6.20306 11.2842 6.89381 13.6924 8.95137 14.3973ZM2.45536 10.9024C2.45536 10.9024 4.6158 7.70124 8.95137 7.37818V6.21812C4.1455 6.59992 0.000976562 10.6528 0.000976562 10.6528C0.000976562 10.6528 2.35248 17.4516 8.95137 18.0683V16.8349C4.10141 16.2328 2.45536 10.9024 2.45536 10.9024Z",
    fill: "#76B900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_5682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNvidiaSymbol);
export default __webpack_public_path__ + "static/media/nvidia_symbol.9d7c6fe456997952f23eedd9e48ca580.svg";
export { ForwardRef as ReactComponent };